import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_ANALYTICS_URL
  // timeout: 5000 // timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    const token = window.$cookies.get('_session')

    if (token) {
      config.headers['Authorization'] = getToken(token)
    }
    return config
  },
  error => {
    // Handle error
    console.error(error)
    Promise.reject(error)
  }
)

const getToken = (token) => {
  const authType = `Bearer ${token}`
  return authType
}

export default service
